'use strict';

var names = ['red', // 0
'orange', // 30
'yellow', // 60
'lime', // 90
'green', // 120
'teal', // 150
'cyan', // 180
'blue', // 210
'indigo', // 240
'violet', // 270
'fuschia', // 300
'pink', // 330
'red'];

var hueName = function hueName(h) {
  var i = Math.round((h - 2) / 30);
  var name = names[i];
  return name;
};

module.exports = hueName;


//////////////////
// WEBPACK FOOTER
// ./~/palx/dist/hue-name.js
// module id = 351
// module chunks = 168707334958949